module.exports = __webpack_public_path__ + "static/media/the-game-national-afl-2026.ab336dce.jpg";